import React, { useState, useCallback, useMemo, useRef, useEffect, useImperativeHandle } from 'react';
import { isFunction } from 'lodash-es';
import Filter from '@/pages/intelligence/components/Filter';
import type { IFilterInstance } from '@/pages/intelligence/components/Filter';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { getLocale } from 'umi';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { formatFilterSaveValue, isValidDate } from '@intelligence/utils/filterUtils';
import useFilterUseHook from '@/pages/intelligence/hooks/useFilterUseHook';
import { getSpecialMetrictableDeviceOptions } from '@/pages/intelligence/utils/speciaFilterUtils';
import { CONSOLE_PLATFORMS } from '@intelligence/_config/storeRank/config';
import { useDeepCompareEffect } from 'ahooks';
import moment from 'moment';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import { useReleaseTime } from '@intelligence/hooks/useReleaseTime';
import { applyFilterTipsToInputList } from '@intelligence/pages/TopCharts/_config/topChartsFilterTipsUtils';
// import { COMPETITOR_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Competitor';
// import useGenreComponent from '@/pages/intelligence/hooks/useGenreComponent';

interface KPITrendsFilterProps extends IBaseProps {
  filterConfirm: Function;
  onChangeExtra?: Function;
  // 点击reset按钮提供给外面调用
  filterReset?: Function;
  timeFilterValues?: any;
  cascaderFilterValue?: any;
  filterValue: any;
  setFilterValue: any;
  filterCfg: any;
  saveParamsMetricsSelection?: any;
  isBasicLoading?: boolean;
  isNewFilterExtend?: boolean;
  sinceReleaseTime?: string;
  earliestDataTime?: string;
  onToggleMoreFilter?: Function;
  setSelectMetricsOptions?: any;
  composedCountrySelectOptionsCur?: any;
  composedCountryOptionsMap?: any;
  updateRegionOptions?: Function;
  defaultInputList: any[];
  // Add logging props
  gameId?: string;
  gameName?: string;
  onFilterLog?: (filterKey: string, filterValue: any, prevValue: any, gameId: string, gameName: string) => void; // Allow custom logging function with game context
  extendPageId?: string;
  firstRowLeading?: React.ReactNode;
}

/**
 * CommonFilter 组件实例
 */
export interface ICommonFilterInstance extends IFilterInstance {}

const CommonFilter: React.ForwardRefRenderFunction<ICommonFilterInstance, KPITrendsFilterProps> = (props, ref) => {
  const {
    filterCfg,
    onToggleMoreFilter = () => {},
    defaultInputList = [],
    filterConfirm,
    onChangeExtra,
    timeFilterValues,
    cascaderFilterValue,
    filterValue,
    setFilterValue,
    updateRegionOptions,
    isNewFilterExtend = false,
    rangeTimeComponentDefault,
    sinceReleaseTime,
    earliestDataTime,
    filterReset,
    platformSourceListCur, // 传入combine游戏商店源选项列
    regionOptions,
    getRadioOptionsTips,
    // composedCountrySelectOptionsCur,
    composedCountryOptionsMap,
    isBasicLoading = false,
    mainGenreOptions,
    releaseTimeComponentDefault,
    exportTableCom,
    // Add logging props
    gameId,
    gameName,
    onFilterLog,
    extendPageId,
    firstRowLeading,
  } = props;
  const locale = getLocale();
  // console.log('CommonFilterCommonFilter', props);
  // console.log('historyhistory', history);
  // console.log('useHistoryuseHistory', useHistory);
  // 默认筛选器将要使用的参数
  // const urlParams: any = getDbiUrlParams(history);
  // const urlActiveParams = urlParams?.segment;
  // const { filterData } = useFilterSaveHook({
  //   filterSaveType: filterCfg?.filterSaveType,
  // });
  const specialParams = filterCfg?.specialParams || {};
  const getCompaniesFetch = filterCfg?.getCompaniesFetch;
  const defaultValue = filterCfg?.defaultValue || {};
  const {
    isCompareGameSelection,
    steamTagOptions = [],
    gameModeOptions = [],
    gameEngineOptions = [],
    publisherClassOptions = [],
    cascaderFooterMsg,
    disabledDataSources,
    calibrationMetricsSwitcher,
  } = specialParams;
  // const {
  //   regionOptions = [],
  //   groupOptionsData = [],
  //   gsdDeviceOptions = [],
  //   gsdSegmentOptions = [],
  //   steamTagOptions = [],
  //   gameModeOptions = [],
  //   digitalDeviceOptions = getDeviceOptionByType('DigitalRevenue'),
  //   metricTableDeviceOptions = getDeviceOptionByType('PCConsoleMetricsTable'),
  //   physicalDeviceOptions = getDeviceOptionByType('PhysicalRevenue'),
  //   mauDeviceOptions = getDeviceOptionByType('MAU'),
  //   lifetimeDeviceOptions = getDeviceOptionByType('LifeTimePlayers'),
  //   isCompareGameSelection,
  // } = specialParams || {};
  // const { isOperate, isOperateDetail, detailFilterExtend, filterExtend } =
  //   useFilterExtend({});
  // 继承逻辑在这写
  // formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  const { setFilterExtend, resetFilterExtend } = useFilterExtend({ pageId: extendPageId });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [resetFilterValue, setResetFilterValue] = useState(
  //   filterCfg?.resetFilterValue,
  // );
  const [resetFilterValue, setResetFilterValue] = useState(filterCfg?.resetFilterValue);
  // const resetFilterValue = filterCfg?.resetFilterValue;

  const formatFormValue = (values: any) => {
    const newFilterValues = formatFilterSaveValue({
      values,
    });
    return newFilterValues;
  };

  // const {
  //   genreRef,
  //   genreSource,
  //   mainGenres,
  //   subGenres,
  //   handleGenresChange,
  //   handleReset: handleGenresReset,
  // } = useGenreComponent(props);
  const steamTagRef = useRef();
  const gameModeRef = useRef();
  const gameEngineRef = useRef();
  const companyRef = useRef();
  const publisherCompanyRef = useRef();
  const developerRef = useRef();
  const platformRef = useRef();

  const { minReleaseTime, maxReleaseTime, getAllCompaniesFilterParams } = useReleaseTime({});

  // const { userInfo } = useSelector((state: any) => {
  //   const { userInfo } = state.home;
  //   return {
  //     userInfo,
  //   };
  // });

  // 公共筛选器需要的useState状态数据
  // const [filterLoading, setFilterLoading] = useState(true);
  // const [inputList, setInputList] = useState(defaultInputList);
  // 要写一个中间hooks来接收，保证唯一性
  // const [regionOptions, setRegionOptions] = useState([]);
  // const [metricSaveDatas, setMetricSaveDatas] = useState({});

  // 筛选器初始化，对应筛选器范围确认
  // useEffect(() => {}, [inputList]);

  const onConfirm = useCallback(
    (
      value = {} as any /** 筛选器数据 */,
      apiValue = {} as any /** 筛选器转换后的数据 */,
      isCustomLayoutFilter = false,
    ) => {
      let valueTemp = value;
      let apiValueTemp = apiValue;
      // console.log('onConfirm-value', value);
      // console.log('onConfirm-apiValue', apiValue);
      if (isCustomLayoutFilter) {
        valueTemp = {
          ...valueTemp,
          myFilter: {
            value: '',
          },
        } as any;
        apiValueTemp = {
          ...apiValueTemp,
          myFilter: {
            value: '',
          },
        } as any;
      }
      // console.log('filterConfirm-valueTemp', valueTemp);
      // 调用通过筛选器值过滤方法
      filterConfirm(valueTemp, false, false, true);

      if (!isNewFilterExtend) {
        // console.log('apiValueTempapiValueTemp333', apiValueTemp);
        setFilterExtend(apiValueTemp);
      }
    },
    [filterConfirm],
  );

  // 根据筛选器配置，设置最新的inputlist
  const inputListCur = useMemo(() => {
    // console.log('defaultInputList~~~~~~~~~~88888', defaultInputList);
    // console.log('filterValue~~~~~~~~~~88888', filterValue);
    let inputListNew = [...defaultInputList];
    // 如果是compare-pcconsole筛选器，并且没有选择游戏的时候，其他筛选器不显示
    if (isCompareGameSelection) {
      inputListNew = inputListNew?.map((item) => {
        const visibleNum =
          item?.key !== filterKeyMap.ALL_Games && filterValue[filterKeyMap.ALL_Games]?.value?.length === 0 ? 2 : 1;
        return {
          ...item,
          visibleinlist: visibleNum,
        };
      });
    }

    // 特殊情况判断
    inputListNew = inputListNew?.map((item) => {
      // 如果是compare-pcconsole筛选器，align_to_release为true的时候，显示releaseDate筛选器
      if (item?.key === filterKeyMap.RANGE_RELEASE_TIME) {
        return {
          ...item,
          visibleinlist: filterValue[filterKeyMap.ALIGN_TO_RELEASE]?.value === true ? item?.visibleinlist : 2,
        };
      }
      // Compare-Multi-dimension，根据Align to Release筛选器切换，是否展示时间筛选器
      if (
        inputListNew?.findIndex((item: any) => item.key === filterKeyMap.ALIGN_TO_RELEASE) > -1 &&
        item?.key === filterKeyMap.RANGE_TIME
      ) {
        return {
          ...item,
          visibleinlist: filterValue[filterKeyMap.ALIGN_TO_RELEASE]?.value === true ? 2 : item?.visibleinlist,
        };
      }

      // 4-segment 场景下，根据 overlapSteam_players 的值控制 engagement level 筛选器的显隐
      // played_play: 显示 Game A + Game B (TWO)
      // played_wishlist: 仅显示 Game A (TWO，隐藏 B 部分由组件内部处理)
      // wishlisted_play: 仅显示 Game B (SEGEMENT 单选)
      // wishlisted_wishlist: 都隐藏
      if (item?.key === filterKeyMap.ENGAGELEVEL_SEGEMENT_TWO && filterValue[filterKeyMap.OVERLAPSTEAM_PLAYERS]) {
        const segmentValue = filterValue[filterKeyMap.OVERLAPSTEAM_PLAYERS]?.value;
        // played_play: 显示 A+B; played_wishlist: 仅显示 A（通过 showOnlyA 标识）
        const showTwoFilter = segmentValue === 'played_play' || segmentValue === 'played_wishlist';
        return {
          ...item,
          visibleinlist: showTwoFilter ? 1 : 2,
          showOnlyA: segmentValue === 'played_wishlist',
        };
      }

      if (item?.key === filterKeyMap.ENGAGELEVEL_SEGEMENT) {
        const segmentValue = filterValue[filterKeyMap.OVERLAPSTEAM_PLAYERS]?.value;
        // wishlisted_play: 仅显示 Game B Playtime (单选)
        return {
          ...item,
          visibleinlist: segmentValue === 'wishlisted_play' ? 1 : 2,
        };
      }
      if (item?.key === filterKeyMap.REVENUE_GROWTH_TWO) {
        return {
          ...item,
          buttonTextA:
            filterValue[filterKeyMap.OVERLAPSTEAM_PLAYERS]?.value === 'played'
              ? 'dbi_overlapsteam_played_play_percent'
              : 'dbi_overlapsteam_wishlisted_play_percent',
          buttonTextB:
            filterValue[filterKeyMap.OVERLAPSTEAM_PLAYERS]?.value === 'played'
              ? 'dbi_overlapsteam_played_wishlist_percent'
              : 'dbi_overlapsteam_wishlisted_wishlist_percent',
        };
      }

      // combine-游戏详情-storerank，根据商店数据源筛选器切换，是否展示国家地区提示
      if (
        inputListNew?.findIndex((item: any) => item.key === filterKeyMap.COMPOSED_SELECT) > -1 &&
        inputListNew?.find((item: any) => item.key === filterKeyMap.COMPOSED_SELECT)?.isOnlyParent === true &&
        item?.key === filterKeyMap.TIPICON
      ) {
        return {
          ...item,
          visibleinlist: filterValue[filterKeyMap.COMPOSED_SELECT]?.value?.parent === 'steam' ? 1 : 2,
        };
      }

      if (item?.key === filterKeyMap.DIGITAL_SEGMENT_MULTIPLE && specialParams?.digitalSegementTips) {
        return { ...item, tips: specialParams?.digitalSegementTips };
      }

      if (item?.key === filterKeyMap.METRICTABLE_DEVICE) {
        return {
          ...item,
          options: getSpecialMetrictableDeviceOptions(
            item?.options,
            filterValue[filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]?.value?.metrics,
          ),
        };
      }
      if (item?.key === filterKeyMap.COMPOSED_SELECT) {
        return {
          ...item,
          parentOptions: platformSourceListCur,
          isOnlyParent: filterValue[filterKeyMap.STORERANK_SEGEMENT]?.value === 'rank',
        };
      }

      // 更新最早有数据时间
      if (rangeTimeComponentDefault || earliestDataTime || sinceReleaseTime) {
        if (item?.key === filterKeyMap.RANGE_TIME) {
          return {
            ...item,
            componentDefault: rangeTimeComponentDefault,
            earliestDataTime,
            sinceReleaseTime,
          };
        }
      }

      // 更新最早有数据时间
      if (mainGenreOptions) {
        if (item?.key === filterKeyMap.DIGITAL_SEGMENT_MULTIPLE) {
          return {
            ...item,
            optionsOutList: mainGenreOptions,
          };
        }
      }

      // 更新通用国家筛选器列表
      if (item?.key === filterKeyMap.REGION || item?.key === filterKeyMap.PUBLISHER_REGION) {
        let itemTemp = {
          ...item,
        };

        // combine-游戏详情-storerank，根据商店数据源筛选器切换，决定是否展示国家筛选器或不同国家地区筛选器
        if (
          inputListNew?.findIndex((item: any) => item.key === filterKeyMap.COMPOSED_SELECT) > -1 &&
          inputListNew?.find((item: any) => item.key === filterKeyMap.COMPOSED_SELECT)?.isOnlyParent === true
        ) {
          itemTemp = {
            ...itemTemp,
            visibleinlist: filterValue[filterKeyMap.COMPOSED_SELECT]?.value?.parent === 'steam' ? 1 : 2,
          };
        }

        // if (item?.pageId === 'combine_detail_storerank_region') {
        //   itemTemp = {
        //     ...itemTemp,
        //     globalInfoKey:
        //       filterValue[filterKeyMap.STORERANK_SEGEMENT]?.value === 'rank'
        //         ? 'dbi_info_global_tips_store_rank_combine_detail_rank_trend'
        //         : 'aggregated_data_under_global',
        //     globalWoChianInfoKey:
        //       filterValue[filterKeyMap.STORERANK_SEGEMENT]?.value === 'rank'
        //         ? 'dbi_info_global_wo_china_tips_store_rank_mobile_detail'
        //         : '',
        //   };
        // }

        if (regionOptions) {
          itemTemp = {
            ...itemTemp,
            options: regionOptions,
          };
          // 供外部接口使用
          updateRegionOptions?.(regionOptions);
        }

        if (isFunction(getRadioOptionsTips)) {
          itemTemp = {
            ...itemTemp,
            getRadioOptionsTips,
          };
        }

        // specialParams.disableNoChina 显式传入时优先使用
        // 未传入时保持 defaultInputList 中的字面值，避免影响其他入口的既有行为
        if (specialParams?.disableNoChina !== undefined) {
          itemTemp = {
            ...itemTemp,
            disableNoChina: specialParams.disableNoChina,
          };
        }

        return itemTemp;
      }

      // combine-游戏详情-storerank，根据商店数据源筛选器切换，决定是否展示国家筛选器或不同国家地区筛选器
      if (item?.key === filterKeyMap.COMPOSED_COUNTRY_SELECT) {
        if (
          inputListNew?.findIndex((item: any) => item.key === filterKeyMap.COMPOSED_SELECT) > -1 &&
          inputListNew?.find((item: any) => item.key === filterKeyMap.COMPOSED_SELECT)?.isOnlyParent === true
        ) {
          return {
            ...item,
            options:
              composedCountryOptionsMap[filterValue[filterKeyMap.COMPOSED_SELECT]?.value?.parent] ||
              composedCountryOptionsMap.playstation,
            visibleinlist: CONSOLE_PLATFORMS.includes(filterValue[filterKeyMap.COMPOSED_SELECT]?.value?.parent) ? 1 : 2,
            regionsOptionsMap: composedCountryOptionsMap,
          };
        }
      }

      if (item?.key === filterKeyMap.ALL_COMPANYS) {
        return {
          ...item,
          ref: companyRef,
          getCompanies: getCompaniesFetch,
          ...getAllCompaniesFilterParams(), // 分离出来的获取参数和成功后的处理函数
        };
      }

      if (item?.key === filterKeyMap.PUBLISHER_COMPANY) {
        return {
          ...item,
          ref: publisherCompanyRef,
          getCompanies: getCompaniesFetch,
          ...getAllCompaniesFilterParams(),
        };
      }

      if (item?.key === filterKeyMap.DEVELOPER) {
        return {
          ...item,
          ref: developerRef,
          getCompanies: getCompaniesFetch,
          ...getAllCompaniesFilterParams(),
        };
      }

      // if (item?.key === filterKeyMap.GENRETOR) {
      //   return {
      //     ...item,
      //     className: COMPETITOR_GUIDE_CLASSNAMES.ELEMENT3,
      //     default: defaultValue[filterKeyMap.GENRETOR],
      //     disableAnnie: specialParams?.disableAnnie,
      //     disableIegg: specialParams?.disableIegg,
      //     genreData: {
      //       genreRef,
      //       genreSource,
      //       mainGenres,
      //       subGenres,
      //       handleGenresChange,
      //       handleGenresReset,
      //     },
      //     entityType: specialParams?.entityType,
      //   };
      // }

      if (steamTagOptions?.length && item?.key === filterKeyMap.STEAM_TAGS) {
        return {
          ...item,
          savePopupVisble: 1,
          key: filterKeyMap.STEAM_TAGS,
          AWidth: 440,
          ref: steamTagRef,
          default: defaultValue[filterKeyMap.STEAM_TAGS],
          options: steamTagOptions,
        };
      }
      if (item?.key === filterKeyMap.PUBLISHER_CLASS) {
        return {
          ...item,
          savePopupVisble: 1,
          key: filterKeyMap.PUBLISHER_CLASS,
          AWidth: 440,
          default: defaultValue[filterKeyMap.PUBLISHER_CLASS],
          options: publisherClassOptions,
        };
      }
      if (item?.key === filterKeyMap.GAME_MODE) {
        return {
          savePopupVisble: 1,
          key: filterKeyMap.GAME_MODE,
          AWidth: 370,
          ref: gameModeRef,
          default: defaultValue[filterKeyMap.GAME_MODE],
          options: gameModeOptions,
          selectorConfig: {
            placeholder: 'dbi_top_game_mode_placeholder',
            searchPlaceholder: 'dbi_top_game_mode_search_placeholder',
            label: 'dbi_top_game_mode',
            tipLabel: 'dbi_top_game_mode',
            tipText: 'dbi_top_game_mode_tip',
          },
        };
      }
      if (item?.key === filterKeyMap.GAME_ENGINE) {
        return {
          savePopupVisble: 1,
          key: filterKeyMap.GAME_ENGINE,
          AWidth: 440,
          ref: gameEngineRef,
          default: defaultValue[filterKeyMap.GAME_ENGINE],
          options: gameEngineOptions,
          selectorConfig: {
            placeholder: 'dbi_top_game_engine_placeholder',
            searchPlaceholder: 'dbi_top_game_engine_search_placeholder',
            label: 'dbi_top_game_engine',
            tipLabel: 'dbi_top_game_engine',
            tipText: 'dbi_top_game_engine_tip',
            logicLabel: 'dbi_game_engine_logic_label',
            logicTipText: 'dbi_game_engine_logic_tip',
          },
        };
      }

      // // 更新 SteamTag 筛选器列表
      // if (steamTagOptions?.length && item?.key === filterKeyMap.STEAM_TAGS) {
      //   return {
      //     ...item,
      //     options: steamTagOptions,
      //   };
      // }
      // // 更新 GameMode 筛选器列表
      // if (gameModeOptions?.length && item?.key === filterKeyMap.GAME_MODE) {
      //   return {
      //     ...item,
      //     options: gameModeOptions,
      //   };
      // }

      // 更新Release时间范围
      if (minReleaseTime && maxReleaseTime) {
        if (item?.key === filterKeyMap.RELEASE_TIME) {
          return {
            ...item,
            range: [moment(minReleaseTime), moment(maxReleaseTime)],
          };
        }
      }

      if (item?.key === filterKeyMap.PLATFORMCASCADER) {
        return {
          ...item,
          ref: platformRef,
        };
      }

      if (item?.key === filterKeyMap.CASCADER) {
        return {
          ...item,
          options: {
            ...item?.options,
            footerMsg: cascaderFooterMsg || '',
          },
        };
      }

      if (item?.key === filterKeyMap.METRIC_SELECT_FOR_KPI_TREND) {
        return { ...item, disabledDataSources };
      }

      if (item?.key === filterKeyMap.KPITRENDS_CALIBRATION_METRICS_SWITCHER) {
        return { ...item, ...calibrationMetricsSwitcher };
      }

      // 更新 HotTagsSource 筛选器的 options 和默认值
      if (item?.key === filterKeyMap.HOT_TAGS_SOURCE) {
        return {
          ...item,
          options: specialParams?.hotTagsOptions || item?.options || [],
          hotTagDefaultValue: specialParams?.filterTagName
            ? (specialParams?.hotTagsOptions || []).find((opt: any) => opt?.name === specialParams.filterTagName)
            : item.hotTagDefaultValue,
          onHotTagConfirm: specialParams?.onHotTagConfirm || item?.onHotTagConfirm,
        };
      }

      return item;
    });

    inputListNew = applyFilterTipsToInputList(inputListNew, specialParams?.filterTips);

    // console.log('inputListNewinputListNew~~~~~~~~~~', inputListNew);
    return inputListNew;
  }, [
    regionOptions,
    getRadioOptionsTips,
    defaultInputList,
    filterValue,
    locale,
    rangeTimeComponentDefault,
    earliestDataTime,
    sinceReleaseTime,
    platformSourceListCur,
    composedCountryOptionsMap,
    getAllCompaniesFilterParams,
    getCompaniesFetch,
    steamTagOptions,
    gameModeOptions,
    gameEngineOptions,
    publisherClassOptions,
    mainGenreOptions,
    cascaderFooterMsg,
    calibrationMetricsSwitcher,
    JSON.stringify(specialParams?.hotTagsOptions),
    specialParams?.filterTagName,
    specialParams?.onHotTagConfirm,
    JSON.stringify(specialParams?.filterTips ? Object.keys(specialParams.filterTips) : null),
  ]);

  // 还原最早有数据的日期
  useEffect(() => {
    let newResetFilterValue = { ...resetFilterValue };
    if (filterCfg?.filterKeyList?.includes(filterKeyMap.RANGE_TIME)) {
      const defaultRangeTimeType = resetFilterValue?.[filterKeyMap.RANGE_TIME]?.type;
      newResetFilterValue = {
        ...newResetFilterValue,
        [filterKeyMap.RANGE_TIME]: {
          type: defaultRangeTimeType,
          value: rangeTimeComponentDefault?.[defaultRangeTimeType],
        },
      };
    }
    if (filterCfg?.filterKeyList?.includes(filterKeyMap.RELEASE_TIME)) {
      newResetFilterValue = {
        ...newResetFilterValue,
        [filterKeyMap.RELEASE_TIME]: {
          type: 'date',
          value: releaseTimeComponentDefault?.date,
        },
      };
    }
    setResetFilterValue(newResetFilterValue);
  }, [JSON.stringify(rangeTimeComponentDefault), JSON.stringify(releaseTimeComponentDefault)]);

  const { onFilterChange } = useFilterUseHook({
    defaultValue: filterValue,
    formValue: filterValue,
    setFormValue: setFilterValue,
    formatFormValue,
    onConfirm,
    onChangeExtra,
    inputList: inputListCur,
    filterSaveType: filterCfg?.filterSaveType,
  });

  /** 时间筛选器值由父组件更新 */
  const updateFormValue = (timeFilterValues: any, cascaderFilterValue?: any) => {
    let filterValueTmp = { ...filterValue };

    if (Array.isArray(timeFilterValues?.value) && timeFilterValues?.value?.length > 1) {
      // 更新接口返回的时间
      if (isValidDate(timeFilterValues?.value?.[0]) && isValidDate(timeFilterValues?.value?.[1])) {
        filterValueTmp = {
          ...filterValueTmp,
          [filterKeyMap.RANGE_TIME]: {
            type: feachTimeTypeToFilterTimeType(timeFilterValues?.type), // TODO
            value: [moment(timeFilterValues?.value?.[0]), moment(timeFilterValues?.value?.[1])],
          },
        };
      }
    }

    if (!!cascaderFilterValue?.value) {
      filterValueTmp = {
        ...filterValueTmp,
        [filterKeyMap.CASCADER]: {
          value: cascaderFilterValue.value,
        },
      };
    }

    setFilterValue(filterValueTmp);
  };

  /** 时间筛选器值如时间筛选器、保存筛选器的值、 */
  useDeepCompareEffect(() => {
    updateFormValue(timeFilterValues, cascaderFilterValue);
  }, [timeFilterValues, cascaderFilterValue]);

  const onReset = () => {
    const newFormValue = resetFilterValue;
    // genreRef.current?.reset();
    companyRef?.current?.reset();
    publisherCompanyRef?.current?.reset();
    developerRef?.current?.reset();
    steamTagRef?.current?.reset();
    gameModeRef?.current?.reset();
    gameEngineRef?.current?.reset();
    platformRef?.current?.reset();
    resetFilterExtend();
    setFilterValue?.(newFormValue);
    if (filterReset instanceof Function) {
      filterReset(newFormValue);
    }

    // 如果有默认 HotTag，reset 完成后重新触发 HotTag 选中
    // 走统一的下拉选项逻辑，恢复默认 HotTag 及其对应的筛选条件
    const { onHotTagConfirm: resetHotTagConfirm, hotTagDefaultOption: resetHotTagDefaultOption } = specialParams;
    if (resetHotTagDefaultOption && resetHotTagConfirm) {
      resetHotTagConfirm(resetHotTagDefaultOption);
    }
  };

  // Create logging callback for filter changes
  const handleFilterLog = useCallback((key: string, value: any, newValue: any) => {
    console.log('CommonFilter: User changed filter:', key, { value, newValue });

    // Use the custom logging function passed from parent component
    if (onFilterLog && typeof onFilterLog === 'function') {
      onFilterLog(key, value, newValue, gameId || '', gameName || '');
    }
  }, [onFilterLog, gameId, gameName]);

  const filterRef = useRef<IFilterInstance | null>(null);

  useImperativeHandle(ref, () => ({
    setValueAndConfirm: (partialValue: IRecord, options?: { resetToDefault?: boolean }) => {
      filterRef.current?.setValueAndConfirm(partialValue, options);
    },
  }));

  return (
    <Filter
      ref={filterRef}
      value={filterValue}
      inputList={inputListCur}
      onConfirm={onConfirm}
      onChange={onFilterChange}
      onToggleMoreFilter={onToggleMoreFilter}
      iconText={filterCfg?.iconText}
      buttonText={filterCfg?.buttonText}
      showButton={filterCfg?.showConfirmButton}
      isHaveFilterSave={filterCfg?.haveFilterSaveBtn}
      isCustomLayoutFilter={filterCfg?.isCustomLayoutFilter}
      filterSaveType={filterCfg?.filterSaveType}
      filterGroups={filterCfg?.filterGroups}
      defaultValue={resetFilterValue} // 用于reset
      onReset={onReset}
      filterLoading={isBasicLoading}
      exportTableCom={exportTableCom}
      firstRowLeading={firstRowLeading}
      specialParams={specialParams}
      onFilterLog={handleFilterLog}
      enableSticky={filterCfg?.enableSticky}
      stickyTopOffset={filterCfg?.stickyTopOffset}
      stickyHeaderTitle={filterCfg?.stickyHeaderTitle}
      useAutoCollapse={filterCfg?.useAutoCollapse}
    />
  );
};

// @ts-ignore
export default React.forwardRef(CommonFilter);
